import RankingBenefitItem from "./RankingBenefitItem";
import { Tooltip } from "antd";

export default function RankingBenefitSection() {
    return (
        <div className="styles_container__ezTCJ MuiBox-root css-0">
            <div className="MuiBox-root css-gg4vpm">
                <span className="styles_titleSection__1uAdG">Quyền lợi xếp hạng</span>

                <Tooltip
                    placement="bottom"
                    trigger="click"
                    overlayClassName="rank-tooltip-320"
                    title={
                        <ul style={{ margin: "8px 0 0" }}>
                            <li>Vào 0h mỗi ngày, hệ thống sẽ tính điểm xếp hạng cho khách hàng, dựa trên số đơn đã hoàn tất trong thời gian quy định.</li>
                            <li>•  Ví dụ: Hệ thống quy định thời gian tính điểm xếp hạng là 3 tháng tới thời điểm hiện tại. Vào lúc 0h ngày 26/6/2021, 3 tháng gần nhất sẽ được tính từ 01/03/2021 tới 01/06/2021 và cộng 25 ngày tới thời điểm hiện tại (26/6/2021).</li>
                            <li>Quy đổi điểm theo:</li>
                            <li>•  100.000 vnđ sẽ được 1 điểm hoặc theo điểm tích lũy được quy định cho sản phẩm đó.</li>
                            <li>•  Nếu sản phẩm có hệ số nhân sẽ nhân lên tương ứng theo điểm quy đổi.</li>
                            <li>Trường hợp do thiếu sót hay chậm trễ từ phía thuocsi.vn, khách hàng vui lòng liên hệ 1800 2038 hoặc hotro@buymed.com để phản hồi về điểm</li>
                        </ul>
                    }
                >
                    <span style={{ display: "inline-block" }}>
                        <button
                            className="MuiButtonBase-root MuiButton-root MuiButton-text styles_btnHowToCalc__ujLk_"
                            tabIndex={0}
                            type="button"
                        >
                            <span className="MuiButton-label">
                                <svg
                                    className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-vubbuv"
                                    focusable="false"
                                    aria-hidden="true"
                                    viewBox="0 0 24 24"
                                    data-testid="ErrorOutlineOutlinedIcon"
                                >
                                    <path d="M11 15h2v2h-2v-2zm0-8h2v6h-2V7zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" />
                                </svg>
                                Cách tính cấp bậc khách hàng
                            </span>
                            <span className="MuiTouchRipple-root"></span>
                        </button>
                    </span>
                </Tooltip>
            </div>

            <div className="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-2">
                <RankingBenefitItem
                    gridClass="MuiGrid-root MuiGrid-item MuiGrid-grid-md-3 m-960-full"
                    bg="https://cdn-web-next.thuocsi.vn/images/userLoyalty/rank_silver_bg.png"
                    icon="https://cdn-web-next.thuocsi.vn/images/userLoyalty/rank_silver_icon.svg"
                    level="Bậc 1"
                    name="Bạc"
                    color="rgb(137, 137, 137)"
                >
                    <p>Điểm xếp hạng cần đạt: 30</p>
                    <ul>
                        <li>Tham gia Rút thăm may mắn</li>
                        <li>Tham gia chương trình trả thưởng từ Nhà bán hàng</li>
                        <li>Tặng Voucher sinh nhật 30.000đ</li>
                    </ul>
                </RankingBenefitItem>

                <RankingBenefitItem
                    gridClass="MuiGrid-root MuiGrid-item MuiGrid-grid-md-3 m-960-full"
                    bg="https://cdn-web-next.thuocsi.vn/images/userLoyalty/rank_gold_bg.png"
                    icon="https://cdn-web-next.thuocsi.vn/images/userLoyalty/rank_gold_icon.svg"
                    level="Bậc 2"
                    name="Vàng"
                    color="rgb(169, 91, 63)"
                >
                    <p>Điểm xếp hạng cần đạt: 80</p>
                    <ul>
                        <li>Tham gia Rút thăm may mắn</li>
                        <li>Tham gia chương trình trả thưởng từ Nhà bán hàng</li>
                        <li>Voucher sinh nhật 40.000đ</li>
                        <li>Sản phẩm giá hạng Vàng</li>
                        <li>Tham gia Điểm danh nhận quà, vòng quay may mắn…</li>
                        <li>Tham gia chương trình trả thưởng từ nhà bán hàng</li>
                        <li>Tham gia các chương trình quay số trúng thưởng</li>
                        <li>Nhận ưu đãi của các sản phẩm Buymed Tuyển Chọn, sản phẩm mới, sản phẩm Nhân đôi tích lũy…</li>
                    </ul>
                </RankingBenefitItem>

                <RankingBenefitItem
                    gridClass="MuiGrid-root MuiGrid-item MuiGrid-grid-md-3 m-960-full"
                    bg="https://cdn-web-next.thuocsi.vn/images/userLoyalty/rank_platinum_bg.png"
                    icon="https://cdn-web-next.thuocsi.vn/images/userLoyalty/rank_platinum_icon.svg"
                    level="Bậc 3"
                    name="Bạch Kim"
                    color="rgb(70, 117, 132)"
                >
                    <p>Điểm xếp hạng cần đạt: 400</p>
                    <p>Số sản phẩm tích lũy cần đạt: 60</p>
                    <ul>
                        <li>Tham gia Rút thăm may mắn</li>
                        <li>Tham gia chương trình trả thưởng từ Nhà bán hàng</li>
                        <li>Tặng Voucher sinh nhật 50.000đ</li>
                        <li>Sản phẩm giá hạng Bạch Kim</li>
                        <li>Cộng điểm thưởng cho khách hàng thân thiết</li>
                        <li>Tham gia rút thăm may mắn các chương trình có giá trị cao (xe máy, ti vi…)</li>
                        <li>Tham dự chương trình trả thưởng đặc biệt và nhận quà từ Buymed</li>
                        <li>Nhận mẫu thử các sản phẩm mới</li>
                        <li>Miễn phí giao hàng cho 1 đơn hàng có giá trị dưới hạn mức yêu cầu</li>
                        <li>Nhận ưu đãi của các sản phẩm Buymed Tuyển Chọn, sản phẩm mới, sản phẩm Nhân đôi tích lũy…</li>
                    </ul>
                </RankingBenefitItem>

                <RankingBenefitItem
                    gridClass="MuiGrid-root MuiGrid-item MuiGrid-grid-md-3 m-960-full"
                    bg="https://cdn-web-next.thuocsi.vn/images/userLoyalty/rank_diamond_bg.png"
                    icon="https://cdn-web-next.thuocsi.vn/images/userLoyalty/rank_diamond_icon.svg"
                    level="Bậc 4"
                    name="Kim Cương"
                    color="rgb(168, 122, 193)"
                    iconBoxClass="MuiBox-root css-1gpdima"
                >
                    <p>Điểm xếp hạng cần đạt: 2400</p>
                    <p>Số sản phẩm tích lũy cần đạt: 80</p>
                    <ul>
                        <li>Tham gia Rút thăm may mắn</li>
                        <li>Tham gia chương trình trả thưởng từ Nhà bán hàng</li>
                        <li>Tặng Voucher sinh nhật 88.000đ</li>
                        <li>Sản phẩm giá hạng Kim Cương</li>
                        <li>Nhận ưu đãi của các sản phẩm Hàng Điểm</li>
                        <li>Cộng điểm thưởng cho khách hàng thân thiết</li>
                        <li>Tham gia rút thăm may mắn các chương trình có giá trị cao (xe máy, ti vi…)</li>
                        <li>Tham dự chương trình trả thưởng đặc biệt và nhận quà từ Buymed</li>
                        <li>Nhận mẫu thử các sản phẩm mới</li>
                        <li>Miễn phí giao hàng cho 2 đơn hàng có giá trị dưới hạn mức yêu cầu</li>
                        <li>Tham gia các sự kiện VIP, hội thảo trực tuyến, các buổi ra mắt sản phẩm mới</li>
                        <li>Hoàn lại sản phẩm miễn phí: 1 lần/tháng</li>
                        <li>Trải nghiệm mua sắm cá nhân hoá</li>
                        <li>Nhận ưu đãi của các sản phẩm Buymed Tuyển Chọn, sản phẩm mới, sản phẩm Nhân đôi tích lũy…</li>
                    </ul>
                </RankingBenefitItem>
            </div>
        </div>
    );
}
